import React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import ThemeProvider from '../ThemeProvider';
import HeaderContainer from '@configuratorware/configurator-frontendgui/App/Shared/Containers/Header';
import Header from '../../Components/Header';
import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice';
import OptionsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/OptionsList';
import BaseProductPartsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList';
import AmountPrice from '../../Components/AmountPrice/AmountPrice';
import Option from '../../Components/Option/Option';
import OptionsList from '../../Components/OptionsList/OptionsList';
import ProductPartsList from '../../Components/ProductPartsList/ProductPartsList';
import ContextMenu from '../../Components/ContextMenu';
import ClickToAddDoorHint from '../../Components/ClickToAddDoorHint';
import { UsageHintDialog } from '../../Components/UsageHintDialog'; 

const CustomOptionsListContainer = (props) => (
  <OptionsListContainer {...props} Component={OptionsList} OptionComponent={Option} />
);

export default (props) => (
  <ConnectedConfiguratorScreen
    {...props}
    ThemeProvider={ThemeProvider}
    renderHeader={() => <HeaderContainer Component={Header} />}
    renderAmountPrice={(props) => (
      <AmountPriceContainer {...props} AmountPriceComponent={AmountPrice} showReceiveOfferForm={true} />
    )}
    OptionsListContainer={CustomOptionsListContainer}
    renderProductParts={(dispatchAction, onOptionClassificationSelect, selectOptionClassification) => (
      <BaseProductPartsListContainer
        Component={ProductPartsList}
        onSelect={(optionClassification) =>
          onOptionClassificationSelect(dispatchAction, optionClassification, selectOptionClassification)
        }
      />
    )}
    customElements={{
      root: (
        <>
          <ClickToAddDoorHint />
          <ContextMenu />
          <UsageHintDialog/> 
          
        </>
      ),
    }}
  />
);

//